import { Component, Vue } from 'vue-property-decorator'
import AppBar from '@/components/AppBar.vue'
import articulos from '@/store/modules/ArticuloModule'
import carritos from '@/store/modules/CarritoModule'
import auth from '@/store/modules/AuthModule'

import { v4 as uuidv4 } from 'uuid'
import { UnidadMedida, getEmptyUnidadMedida } from '@/types/types'

@Component({
  components: {
    AppBar
  }
})
export default class ArticuloPage extends Vue {
  precio = 1
  cantidad = 1
  total = 1
  unidadMedida: UnidadMedida = getEmptyUnidadMedida()
  detalle = ''
  loading = false
  showArticulo = false

  get articulo () {
    return articulos.current
  }

  get isAuth () {
    return auth.isAuth
  }

  changePrecio (precio: number) {
    this.precio = precio
    this.total = this.precio * this.cantidad
  }

  increment () {
    this.cantidad++
    this.total = this.precio * this.cantidad
  }

  decrement () {
    if (this.cantidad <= 0) return
    this.cantidad--
    this.total = this.precio * this.cantidad
  }

  onAddArticulo () {
    carritos.addItem({
      id: uuidv4(),
      articulo: this.articulo,
      cantidad: this.cantidad,
      unidad_medida: this.unidadMedida,
      detalle: this.detalle,
      sub_total: this.precio * this.cantidad
    })
    this.showArticulo = true
  }

  mounted () {
    this.loading = true
    const id = this.$route.params.id
    articulos.fetchOne(id).finally(() => {
      this.unidadMedida = this.articulo.unidades_medida[0]
      this.precio = this.unidadMedida.precio
      this.changePrecio(this.precio)
      this.loading = false
    })
  }
}
